import {
  type ContentPosition,
  type Positionable,
  type TextInputType,
} from '../components/textbox/textbox.component';
import {
  amountLimitValidators,
  type AmountErrorFormatter,
} from '../validators/amount.validator';

import {
  QuestionBase,
  type QuestionBaseWithoutType,
  type SetValueOptions,
} from './question-base';

export interface IQuestionNumber
  extends QuestionBaseWithoutType<number>, Positionable {
  mask?: string;
  tooltip?: string;
  errorFormatter?: AmountErrorFormatter;
  onFocus?: () => void;
  onBlur?: () => void;
}

export class QuestionNumber
  extends QuestionBase<number>
  implements IQuestionNumber
{
  declare public type?: TextInputType;
  public mask?: string;
  public tooltip?: string;
  public contentPosition?: ContentPosition;
  public errorFormatter?: AmountErrorFormatter;
  public onFocus?: () => void;
  public onBlur?: () => void;

  constructor(options: IQuestionNumber) {
    super(options);
    this.elementType = 'textbox';
    this.type = 'number';

    this.mask = options.mask;
    this.placeholder = options.placeholder;
    this.contentPosition = options.contentPosition || 'before';

    this.onFocus = options.onFocus || (() => {});
    this.onBlur = options.onBlur || (() => {});

    this.tooltip = options.tooltip || '';
    this.errorFormatter = options.errorFormatter;

    this._formatValue ??= this._defaultFormatValue;
  }

  public override initStart(): void {
    this.validators.push(
      amountLimitValidators(
        this.errorFormatter ||
          this.questionControlService.valueErrorFormatter.bind(
            this.questionControlService,
          ),
      ),
    );
  }

  public override setValue(
    value: any,
    opts: SetValueOptions = { emitEvent: true, force: false },
  ): void {
    return super.setValue(this._formatValue(value), opts);
  }

  public override getValue(): number {
    return this._formatValue(super.getValue());
  }

  public override equals(value: any): boolean {
    return this.getValue() === this._formatValue(value);
  }

  private _defaultFormatValue(value: number): number {
    if (value === undefined) {
      return;
    }

    if (String(value).trim() === '' || value === null) {
      return null;
    }

    return +String(value).trim();
  }
}
